import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./AuthModal.css";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verifying...");
  const requestSent = useRef(false); // prevents double request

  useEffect(() => {
    const verifyEmail = async () => {
      if (requestSent.current) return;
      requestSent.current = true;

      try {
        const res = await axios.get(`/api/userauth/verify-email/${token}`);

        if (res.data.success) {
          setStatus("✅ Your email has been verified successfully!");
          setTimeout(() => navigate("/"), 5000);
        } else {
          setStatus(`❌ ${res.data.message}`);
        }
      } catch (err) {
        console.error(err);
        setStatus("❌ Verification failed. Invalid or expired token.");
      }
    };

    if (token) verifyEmail();
  }, []); // only runs ONCE

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.6)",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "30px 40px",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
          textAlign: "center",
        }}
      >
        <h2>Email Verification</h2>
        <p>{status}</p>
      </div>
    </div>
  );
};

export default VerifyEmail;
